import {
  CAR_DATA_MASTER_GET_BUSINESS_UNITS_BEGIN,
  CAR_DATA_MASTER_GET_BUSINESS_UNITS_SUCCESS,
  CAR_DATA_MASTER_GET_BUSINESS_UNITS_FAILURE,
  CAR_DATA_MASTER_GET_BUSINESS_UNITS_DISMISS_ERROR,
} from './constants';
import axios from "axios";
import { REACT_APP_API_ABM_FW, REACT_APP_IMG } from '../../../common/config';
import { FILES_ENDPOINT } from 'cfgCommon/endpoints'
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getBusinessUnits(args = {}) {
  return async (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: CAR_DATA_MASTER_GET_BUSINESS_UNITS_BEGIN,
    });

  try {
    const res = await axios.get(REACT_APP_API_ABM_FW + "/abms/business_unit" + args);
    if (res.data.success) {
      const business_units = res.data.data;
      if (business_units.length > 0) {
        business_units.forEach(business_unit => {
          business_unit['unidadesDeNegocioID'] = { value: business_unit.unidadesDeNegocioID, label: business_unit.unit_type, id: 'unit_type' };
          business_unit['logo'] = '';
          business_unit['carDealership_name'] = business_unit.Branch_office.Car_lot.name;
          business_unit['branch_name'] = business_unit.Branch_office.name;
          business_unit['canDelete'] = true;
          business_unit['files'] = {
            'LOGO': [],
            'FIRMA': []
          };
        });
        if (args !== '') {
          for (const business_unit of business_units) {
            const resLogo = await axios.get(FILES_ENDPOINT + '/CARDEARLERSHIP_LOGO/' + business_unit.Branch_office.Car_lot.id)
            if (resLogo.data.data.length > 0) {
              resLogo.data.data.forEach((item) => {
                business_unit['files']['LOGO'].push(item);
              })
              if (business_unit['files']['LOGO'].length > 0) {
                business_unit['logo'] = REACT_APP_IMG + '/' + business_unit['files']['LOGO'][0].url;
              }
            }
            const resMaestro = await axios.get(FILES_ENDPOINT + '/MAESTRO/' + business_unit.id)
            if (resMaestro.data.data.length > 0) {
              resMaestro.data.data.forEach((item) => {
                business_unit['files']['FIRMA'].push(item);
              })
              if (business_unit['files']['FIRMA'].length > 0) {
                business_unit['firma'] = REACT_APP_IMG + '/' + business_unit['files']['FIRMA'][0].url;
              }
            }
          }
          dispatch({
            type: CAR_DATA_MASTER_GET_BUSINESS_UNITS_SUCCESS,
            data: business_units,
            pagination: res.data.pagination
          });
          return res;
        } else {
              dispatch({
                type: CAR_DATA_MASTER_GET_BUSINESS_UNITS_SUCCESS,
                data: business_units,
                pagination: res.data.pagination
              });
              return res;
            }
          } else {
            dispatch({
              type: CAR_DATA_MASTER_GET_BUSINESS_UNITS_SUCCESS,
              data: [],
              pagination: res.data.pagination
            });
            return res;
          }
        }
      }
      catch (err) {
        dispatch({
          type: CAR_DATA_MASTER_GET_BUSINESS_UNITS_FAILURE,
          data: { error: err },
        });
        return err;
      }
   };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetBusinessUnitsError() {
  return {
    type: CAR_DATA_MASTER_GET_BUSINESS_UNITS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CAR_DATA_MASTER_GET_BUSINESS_UNITS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getBusinessUnitsPending: true,
        getBusinessUnitsError: null,
      };

    case CAR_DATA_MASTER_GET_BUSINESS_UNITS_SUCCESS:
      // The request is success
      return {
        ...state,
        getBusinessUnitsPending: false,
        getBusinessUnitsError: null,
        businessUnitList: [...action.data],
        businessUnitsPagination: { ...action.pagination }
      };

    case CAR_DATA_MASTER_GET_BUSINESS_UNITS_FAILURE:
      // The request is failed
      return {
        ...state,
        getBusinessUnitsPending: false,
        getBusinessUnitsError: action.data.error,
      };

    case CAR_DATA_MASTER_GET_BUSINESS_UNITS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getBusinessUnitsError: null,
      };

    default:
      return state;
  }
}
